import React, { useContext } from "react";
import classes from "./BlogItem.module.css";
import { FiFolder } from "react-icons/fi";
import { RiExternalLinkLine } from "react-icons/ri";
import { ThemeContext } from "../../../ThemeProvider";

const BlogItem = ({ title, desc, link }) => {
  const { dark } = useContext(ThemeContext);

  return (
    <a
      href={link}
      target="_blank"
      className={
        dark
          ? `${classes.blog__item} ${classes.blog__item__dark}`
          : classes.blog__item
      }
    >
      <div
        className={
          dark
            ? `${classes.blog__links} ${classes.blog__links__dark}`
            : classes.blog__links
        }
      >
        <p>
          <FiFolder className={classes.link__icon1} />
        </p>

        <div className={classes.links__right}>
          <p>
            <a href={link} target="_blank">
              <RiExternalLinkLine className={classes.link__icon2} />
            </a>
          </p>
        </div>
      </div>

      <h4>{title}</h4>
      <p>{desc}</p>
    </a>
  );
};

export default BlogItem;
